class CapabilitiesBuilder {
	constructor() {
		this.dropdownMenu = document.querySelector('.tb-selection-trigger')
		this.tbOptions = {
		}
		this.selectedConfiguration = {
			isDevice: false,
			isRealDevice: false,
			browserName: '',
			browserVersion: '',
			deviceName: '',
			platform: ''
		}
		this.protocolMode = 'w3c' // can be w3c or jsonwp
		this.selectedLanguage = 'java'
		this.code = {
			w3c: {
				java: {
					default: `MutableCapabilities capabilities = new MutableCapabilities();
					capabilities.setCapability(CapabilityType.BROWSER_NAME, "%browser%");
capabilities.setCapability(CapabilityType.BROWSER_VERSION, "%version%");
capabilities.setCapability(CapabilityType.PLATFORM_NAME, "%platformName%");
{extra}
					`,
					mobile: `MutableCapabilities capabilities = new MutableCapabilities();
capabilities.setCapability(CapabilityType.BROWSER_NAME, "%browser%");
capabilities.setCapability(CapabilityType.BROWSER_VERSION, "%version%");
capabilities.setCapability(CapabilityType.PLATFORM_NAME, "%platformName%");
capabilities.setCapability("appium:deviceName", "%deviceName%");
{extra}`,
					realMobile: `MutableCapabilities capabilities = new MutableCapabilities();
capabilities.setCapability(CapabilityType.BROWSER_NAME, "%browser%");
capabilities.setCapability(CapabilityType.BROWSER_VERSION, "%version%");
capabilities.setCapability(CapabilityType.PLATFORM_NAME, "%platformName%");
capabilities.setCapability("tb:realDevice", true);
capabilities.setCapability("appium:deviceName", "%deviceName%");
{extra}`
				},
				python: {
					default: `desired_cap = {
   "browserName" : "%browser%",
   "platformName": "%platformName%",
   "browserVersion": "%version%",
   {extra}
}`,
					mobile: `desired_cap = {
   "browserName" : "%browser%",
   "platformName": "%platformName%",
   "browserVersion": "%version%",
   {extra}
}`,
					realMobile: `desired_cap = {
   "browserName" : "%browser%",
   "platformName": "%platformName%",
   "browserVersion": "%version%",
   {extra}
}`
				},
				javascript: {
					default: `const capabilities = {
   "browserName" : "%browser%",
   "platformName": "%platformName%",
   "browserVersion": "%version%",
   {extra}
}`,
					mobile: `const capabilities = {
   "browserName" : "%browser%",
   "platformName": "%platformName%",
   "browserVersion": "%version%",
   {extra}
}`,
					realMobile: `const capabilities = {
   "browserName" : "%browser%",
   "platformName": "%platformName%",
   "browserVersion": "%version%",
   {extra}
}`
				},
				csharp: {
					default: `var capabilities = new ChromeOptions();
capabilities.BrowserVersion = "%version%";
capabilities.PlatformName = "%platformName%";
{extra}`,
					mobile: `var capabilities = new ChromeOptions();
capabilities.BrowserVersion = "%version%";
capabilities.PlatformName = "%platformName%";
capabilities.AddAdditionalOption("appium:deviceName", "%deviceName%");
{extra}`,
					realMobile: `var capabilities = new ChromeOptions();
capabilities.BrowserVersion = "%version%";
capabilities.PlatformName = "%platformName%";
capabilities.AddAdditionalOption("tb:realDevice", true);
capabilities.AddAdditionalOption("appium:deviceName", "%deviceName%");
{extra}`
				},
				ruby: {
					default: `capabilities = {
  browserName: "%browser%",
  browserVersion: "%version%",
  platformName: "%platformName%",
  {extra}
}`,
					mobile: `capabilities = {
  browserName: "%browser%",
  browserVersion: "%version%",
  platformName: "%platformName%",
  "appium:deviceName" => "%deviceName%",
  {extra}
}`,
					realMobile: `capabilities = {
  browserName: "%browser%",
  browserVersion: "%version%",
  platformName: "%platformName%",
  "tb:realDevice" => true,
  "appium:deviceName" => "%deviceName%",
  {extra}
}`
				},
				php: {
					default: `$capabilities = [
    'browserName' => '%browser%',
    'browserVersion' => '%version%',
    'platformName' => '%platformName%',
    {extra}
];`,
					mobile: `$capabilities = [
    'browserName' => '%browser%',
    'browserVersion' => '%version%',
    'platformName' => '%platformName%',
    'appium:deviceName' => '%deviceName%',
    {extra}
];`,
					realMobile: `$capabilities = [
    'browserName' => '%browser%',
    'browserVersion' => '%version%',
    'platformName' => '%platformName%',
    'tb:realDevice' => true,
    'appium:deviceName' => '%deviceName%',
    {extra}
];`
				}
			},
			jsonwp: {
				java: {
					default: `DesiredCapabilities capabilities = new DesiredCapabilities();
					capabilities.setCapability(CapabilityType.BROWSER_NAME, "%browser%");
capabilities.setCapability(CapabilityType.BROWSER_VERSION, "%version%");
capabilities.setCapability(CapabilityType.PLATFORM_NAME, "%platformName%");
{extra}
					`,
					mobile: `DesiredCapabilities capabilities = new DesiredCapabilities();
capabilities.setCapability(CapabilityType.BROWSER_NAME, "%browser%");
capabilities.setCapability(CapabilityType.BROWSER_VERSION, "%version%");
capabilities.setCapability(CapabilityType.PLATFORM_NAME, "%platformName%");
capabilities.setCapability("appium:deviceName", "%deviceName%");
{extra}`,
					realMobile: `DesiredCapabilities capabilities = new DesiredCapabilities();
capabilities.setCapability(CapabilityType.BROWSER_NAME, "%browser%");
capabilities.setCapability(CapabilityType.BROWSER_VERSION, "%version%");
capabilities.setCapability(CapabilityType.PLATFORM_NAME, "%platformName%");
capabilities.setCapability("tb:realDevice", true);
capabilities.setCapability("appium:deviceName", "%deviceName%");
{extra}`
				},
				python: {
					default: `desired_cap = {
					"browserName" : "%browser%",
					"platformName": "%platformName%",
					"browserVersion": "%version%",
					{extra}
					}`,
					mobile: `desired_cap = {
					"browserName" : "%browser%",
					"platformName": "%platformName%",
					"browserVersion": "%version%",
					{extra}
					}`,
					realMobile: `desired_cap = {
					"browserName" : "%browser%",
					"platformName": "%platformName%",
					"browserVersion": "%version%",
					{extra}
					}`
				},
				javascript: {
					default: `const capabilities = {
   "browserName" : "%browser%",
   "platformName": "%platformName%",
   "browserVersion": "%version%",
   {extra}
}`,
					mobile: `const capabilities = {
   "browserName" : "%browser%",
   "platformName": "%platformName%",
   "browserVersion": "%version%",
   {extra}
}`,
					realMobile: `const capabilities = {
   "browserName" : "%browser%",
   "platformName": "%platformName%",
   "browserVersion": "%version%",
   {extra}
}`
				},
				csharp: {
					default: `DesiredCapabilities capabilities = new DesiredCapabilities();
capabilities.SetCapability("browserName", "%browser%");
capabilities.SetCapability("browserVersion", "%version%");
capabilities.SetCapability("platformName", "%platformName%");
{extra}`,
					mobile: `DesiredCapabilities capabilities = new DesiredCapabilities();
capabilities.SetCapability("browserName", "%browser%");
capabilities.SetCapability("browserVersion", "%version%");
capabilities.SetCapability("platformName", "%platformName%");
capabilities.SetCapability("deviceName", "%deviceName%");
{extra}`,
					realMobile: `DesiredCapabilities capabilities = new DesiredCapabilities();
capabilities.SetCapability("browserName", "%browser%");
capabilities.SetCapability("browserVersion", "%version%");
capabilities.SetCapability("platformName", "%platformName%");
capabilities.SetCapability("realDevice", true);
capabilities.SetCapability("deviceName", "%deviceName%");
{extra}`
				},
				ruby: {
					default: `capabilities = Selenium::WebDriver::Remote::Capabilities.new
capabilities[:browserName] = "%browser%"
capabilities[:browserVersion] = "%version%"
capabilities[:platformName] = "%platformName%"
{extra}`,
					mobile: `capabilities = Selenium::WebDriver::Remote::Capabilities.new
capabilities[:browserName] = "%browser%"
capabilities[:browserVersion] = "%version%"
capabilities[:platformName] = "%platformName%"
capabilities[:deviceName] = "%deviceName%"
{extra}`,
					realMobile: `capabilities = Selenium::WebDriver::Remote::Capabilities.new
capabilities[:browserName] = "%browser%"
capabilities[:browserVersion] = "%version%"
capabilities[:platformName] = "%platformName%"
capabilities[:realDevice] = true
capabilities[:deviceName] = "%deviceName%"
{extra}`
				},
				php: {
					default: `$capabilities = DesiredCapabilities::chrome();
$capabilities->setCapability('browserName', '%browser%');
$capabilities->setCapability('browserVersion', '%version%');
$capabilities->setCapability('platformName', '%platformName%');
{extra}`,
					mobile: `$capabilities = DesiredCapabilities::chrome();
$capabilities->setCapability('browserName', '%browser%');
$capabilities->setCapability('browserVersion', '%version%');
$capabilities->setCapability('platformName', '%platformName%');
$capabilities->setCapability('deviceName', '%deviceName%');
{extra}`,
					realMobile: `$capabilities = DesiredCapabilities::chrome();
$capabilities->setCapability('browserName', '%browser%');
$capabilities->setCapability('browserVersion', '%version%');
$capabilities->setCapability('platformName', '%platformName%');
$capabilities->setCapability('realDevice', true);
$capabilities->setCapability('deviceName', '%deviceName%');
{extra}`
				}
			}
		}
		this.init()
		this.addListeners()
	}

	addTbOptions() {
		if (Object.keys(this.tbOptions).length > 0) {
			if (this.selectedLanguage === 'java') {
				if (this.protocolMode === 'w3c') {
					return `
HashMap<String, Object> tbOptions = new HashMap<String, Object>();
${Object.entries(this.tbOptions)
		.map(([key, value]) => typeof value === 'boolean' ? `tbOptions.put("${key}", ${value});` : `tbOptions.put("${key}", "${value}");`)
		.join("\n")}
capabilities.setCapability("tb:options", tbOptions);`
				} else {
					return `
${Object.entries(this.tbOptions)
		.map(([key, value]) => typeof value === 'boolean' ? `capabilities.setCapability("${key}", ${value});` : `capabilities.setCapability("${key}", "${value}");`)
		.join("\n")}`
				}
			} else if (this.selectedLanguage === 'python') {
				if (this.protocolMode === 'w3c') {
					return `'tb:options': {
    ${Object.entries(this.tbOptions)
		.map(([key, value]) => typeof value === 'boolean' ? `"${key}": ${value ? 'True' : 'False'}` : `"${key}": "${value}"`)
		.join(",\n    ")}
  }`
				} else {
					return `${Object.entries(this.tbOptions)
						.map(([key, value]) => typeof value === 'boolean' ? `"${key}": ${value ? 'True' : 'False'}` : `"${key}": "${value}"`)
						.join(",\n")}`
				}
			} else if (this.selectedLanguage === 'javascript') {
				if (this.protocolMode === 'w3c') {
					return `'tb:options': {
    ${Object.entries(this.tbOptions)
		.map(([key, value]) => typeof value === 'boolean' ? `"${key}": ${value}` : `"${key}": "${value}"`)
		.join(",\n    ")}
  }`
				} else {
					return `${Object.entries(this.tbOptions)
						.map(([key, value]) => typeof value === 'boolean' ? `"${key}": ${value}` : `"${key}": "${value}"`)
						.join(",\n")}`
				}
			} else if (this.selectedLanguage === 'csharp') {
				if (this.protocolMode === 'w3c') {
					return `
var tbOptions = new Dictionary<string, object>();
${Object.entries(this.tbOptions)
		.map(([key, value]) => typeof value === 'boolean' ? `tbOptions["${key}"] = ${value};` : `tbOptions["${key}"] = "${value}";`)
		.join("\n")}
capabilities.AddAdditionalOption("tb:options", tbOptions);`
				} else {
					return `
${Object.entries(this.tbOptions)
		.map(([key, value]) => typeof value === 'boolean' ? `capabilities.SetCapability("${key}", ${value});` : `capabilities.SetCapability("${key}", "${value}");`)
		.join("\n")}`
				}
			} else if (this.selectedLanguage === 'ruby') {
				if (this.protocolMode === 'w3c') {
					return `'tb:options' => {
    ${Object.entries(this.tbOptions)
		.map(([key, value]) => typeof value === 'boolean' ? `'${key}' => ${value}` : `'${key}' => '${value}'`)
		.join(",\n    ")}
  }`
				} else {
					return `${Object.entries(this.tbOptions)
						.map(([key, value]) => typeof value === 'boolean' ? `capabilities[:${key}] = ${value}` : `capabilities[:${key}] = '${value}'`)
						.join("\n")}`
				}
			} else if (this.selectedLanguage === 'php') {
				if (this.protocolMode === 'w3c') {
					return `'tb:options' => [
    ${Object.entries(this.tbOptions)
		.map(([key, value]) => typeof value === 'boolean' ? `'${key}' => ${value}` : `'${key}' => '${value}'`)
		.join(",\n    ")}
  ]`
				} else {
					return `${Object.entries(this.tbOptions)
						.map(([key, value]) => typeof value === 'boolean' ? `$capabilities->setCapability('${key}', ${value});` : `$capabilities->setCapability('${key}', '${value}');`)
						.join("\n")}`
				}
			}
		}
		return null
	}

	addListeners() {
		// Language tab switching
		document.querySelectorAll('.lang-tab').forEach(tab => {
			tab.addEventListener('click', (e) => {
				document.querySelectorAll('.lang-tab').forEach(t => {
					t.classList.remove('active', 'bg-white', 'dark:bg-gray-700', 'text-gray-900', 'dark:text-white', 'shadow-sm')
					t.classList.add('text-gray-600', 'dark:text-gray-400', 'hover:text-gray-800', 'dark:hover:text-gray-200')
				})

				e.target.classList.add('active', 'bg-white', 'dark:bg-gray-700', 'text-gray-900', 'dark:text-white', 'shadow-sm')
				e.target.classList.remove('text-gray-600', 'dark:text-gray-400', 'hover:text-gray-800', 'dark:hover:text-gray-200')
				this.selectedLanguage = e.target.getAttribute('data-lang')
				this.renderOutput()
			})
		})

		document.querySelector('#resolution-select').addEventListener('change', (e) => {
			const resolution = e.target.value
			this.tbOptions['screen-resolution'] = resolution
			this.renderOutput()
		})

		document.querySelector('#testName').addEventListener('input', (e) => {
			const name = e.target.value
			if (name.length > 0) {
				this.tbOptions['name'] = name
			} else {
				delete this.tbOptions['name']
			}
			this.renderOutput()
		})

		document.querySelector('#buildName').addEventListener('input', (e) => {
			const buildName = e.target.value
			if (buildName.length > 0) {
				this.tbOptions['build'] = buildName
			} else {
				delete this.tbOptions['build']
			}
			this.renderOutput()
		})

		document.querySelector('#selenium-version-select').addEventListener('change', (e) => {
			const seleniumVersion = e.target.value
			this.tbOptions['selenium-version'] = seleniumVersion
			this.renderOutput()
		})

		document.querySelectorAll('#protocolModes button').forEach(button => {
			button.addEventListener('click', (e) => {
				document.querySelectorAll('#protocolModes button').forEach(btn => {
					btn.classList.remove('bg-blue-50', 'dark:bg-blue-900/40')
					btn.classList.add('bg-white', 'dark:bg-gray-800')
				})
				
				e.currentTarget.classList.add('bg-blue-50', 'dark:bg-blue-900/40')
				e.currentTarget.classList.remove('bg-white', 'dark:bg-gray-800')

				this.protocolMode = e.currentTarget.dataset.mode
				this.renderOutput()
			})
		})

		// Debugging options listeners
		document.querySelectorAll('input[name="screenrecorder"]').forEach(radio => {
			radio.addEventListener('change', (e) => {
				const screenrecorderValue = e.target.value === 'true'
				if (!screenrecorderValue) {
					this.tbOptions['screenrecorder'] = false
				} else {
					delete this.tbOptions['screenrecorder']
				}
				this.renderOutput()
			})
		})

		document.querySelectorAll('input[name="screenshot"]').forEach(radio => {
			radio.addEventListener('change', (e) => {
				const screenshotValue = e.target.value === 'true'
				if (screenshotValue) {
					this.tbOptions['screenshot'] = true
				} else {
					delete this.tbOptions['screenshot']
				}
				this.renderOutput()
			})
		})

		document.querySelectorAll('input[name="recordLogs"]').forEach(radio => {
			radio.addEventListener('change', (e) => {
				const recordLogsValue = e.target.value === 'true'
				if (!recordLogsValue) {
					this.tbOptions['recordLogs'] = false
				} else {
					delete this.tbOptions['recordLogs']
				}
				this.renderOutput()
			})
		})

		// Customization options listeners
		document.querySelectorAll('input[name="headless"]').forEach(radio => {
			radio.addEventListener('change', (e) => {
				const headlessValue = e.target.value === 'true'
				if (headlessValue) {
					this.tbOptions['headless'] = true
				} else {
					delete this.tbOptions['headless']
				}
				this.renderOutput()
			})
		})
		document.querySelector('#timezone').addEventListener('input', (e) => {
			const timezone = e.target.value.trim()
			if (timezone) {
				this.tbOptions['timeZone'] = timezone
			} else {
				delete this.tbOptions['timeZone']
			}
			this.renderOutput()
		})

		document.querySelector('#prerun').addEventListener('input', (e) => {
			const prerun = e.target.value.trim()
			if (prerun) {
				this.tbOptions['prerun'] = prerun
			} else {
				delete this.tbOptions['prerun']
			}
			this.renderOutput()
		})

		document.querySelector('#upload').addEventListener('input', (e) => {
			const upload = e.target.value.trim()
			if (upload) {
				this.tbOptions['upload'] = upload
			} else {
				delete this.tbOptions['upload']
			}
			this.renderOutput()
		})

		document.querySelector('#geolocation').addEventListener('change', (e) => {
			const geoCountryCode = e.target.value
			if (geoCountryCode) {
				this.tbOptions['testingbot.geoCountryCode'] = geoCountryCode
			} else {
				delete this.tbOptions['testingbot.geoCountryCode']
			}
			this.renderOutput()
		})
	}

	init() {
		const menuId = this.dropdownMenu.getAttribute('data-menu')
		const apiUrl = this.dropdownMenu.getAttribute('data-apiUrl') || '/support/picker/web-automate.json'
		const osFamily = this.dropdownMenu.getAttribute('data-initial-osFamily') || 'windows'
		const osName = this.dropdownMenu.getAttribute('data-initial-osName') || 'Windows 11'
		const browserName = this.dropdownMenu.getAttribute('data-initial-browserName') || 'chrome'
		const browserVersion = this.dropdownMenu.getAttribute('data-initial-browserVersion')
		const deviceName = this.dropdownMenu.getAttribute('data-initial-deviceName') || undefined
		const deviceVersion = this.dropdownMenu.getAttribute('data-initial-deviceVersion') || undefined
		this.selectedConfiguration = {
			isDevice: false,
			isRealDevice: false,
			browserName: browserName,
			browserVersion: browserVersion,
			deviceName: deviceName,
			platform: osName
		}
		this.picker = new window.EnvironmentPicker(menuId, {
			osFamily: osFamily,
			osName: osName,
			browserName: browserName,
			browserVersion: browserVersion,
			deviceName: deviceName,
			deviceVersion: deviceVersion
		}, apiUrl)

		this.dropdownMenu.addEventListener('click', (e) => {
			this.picker.toggle()
		})

		this.picker.setClickHandler(this.onPickEnv.bind(this))
	}

	onPickEnv(data) {
		this.selectedConfiguration.isRealDevice = data.isRealDevice || false
		this.selectedConfiguration.browserName = data.browser
		this.selectedConfiguration.browserVersion = data.browserVersion
		this.selectedConfiguration.platform = data.osName
		this.selectedConfiguration.isDevice = data.isDevice
		this.selectedConfiguration.deviceName = data.deviceName
		this.selectedConfiguration.deviceVersion = data.deviceVersion

		document.querySelectorAll('.tb-label-os').forEach(label => {
			label.innerHTML = data.osName
		})
		document.querySelectorAll('.tb-label-browser').forEach(label => {
			label.innerHTML = `${this.capitalizeFirstLetter(data.browser)} ${data.browserVersion}`
		})
		const platformUrl = this.getOSIcon(data.osFamily)
		document.querySelectorAll('.tb-os-icon').forEach(img => {
			if (img.src !== platformUrl) {
				img.src = platformUrl
			}
		})
		const browserUrl = data.browserIconUrl
		document.querySelectorAll('.tb-browser-icon').forEach(img => {
			if (img.src !== browserUrl) {
				img.src = browserUrl
			}
		})
		this.renderOutput()
	}

	getTemplateCode() {
		const presets = this.code[this.protocolMode]
		if (this.selectedConfiguration.isRealDevice) {
			return presets[this.selectedLanguage].realMobile
		} else if (this.selectedConfiguration.isDevice) {
			return presets[this.selectedLanguage].mobile
		} else {
			return presets[this.selectedLanguage].default
		}
	}

	capitalizeFirstLetter (val) {
		return String(val).charAt(0).toUpperCase() + String(val).slice(1)
	}

	translateBrowserName (browserName) {
		if (browserName === 'edge') {
			return 'MicrosoftEdge'
		}

		return browserName
	}

	getOSIcon(osFamily) {
		const icons = {
			'windows': '/assets/environments/svg/windows11.svg',
			'macos': '/assets/environments/svg/ios.svg',
			'linux': '/assets/environments/svg/linux.svg',
			'ios': '/assets/environments/svg/ios.svg',
			'android': '/assets/environments/svg/android.svg'
		}
		return icons[osFamily] || '/assets/environments/svg/windows11.svg'
	}

	renderOutput () {
		const output = document.querySelector('#code-output code')
		let templateCode = this.getTemplateCode()
		const tbOptions = this.addTbOptions()
		if (tbOptions !== null) {
			templateCode = templateCode.replace('{extra}', tbOptions)
		} else {
			templateCode = templateCode.replace('{extra}', '')
		}
		templateCode = templateCode.replace('%browser%', this.translateBrowserName(this.selectedConfiguration.browserName))
		templateCode = templateCode.replace('%platformName%', this.translatePlatformName(this.selectedConfiguration.platform))
		templateCode = templateCode.replace('%version%', this.selectedConfiguration.browserVersion)
		templateCode = templateCode.replace('%deviceName%', this.selectedConfiguration.deviceName)
		output.innerHTML = hljs.highlight(templateCode, { language: this.selectedLanguage }).value
	}

	translatePlatformName (platformName) {
		if (platformName === 'Ubuntu') {
			return 'LINUX'
		}

		return platformName
	}
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
	window.capabilitiesBuilder = new CapabilitiesBuilder()
})

// Make generateCapabilities available globally for the existing environment picker
window.generateCapabilities = () => {
	if (window.capabilitiesBuilder) {
		window.capabilitiesBuilder.generateCapabilities()
	}
}